import '../styles/components/Loader.scss';

const Loader = () => <div className="box"><div className="Loader" /></div>;

export default Loader;
